module.exports = __webpack_public_path__ + "static/media/IMG_20201031_0005.9da28e06.jpg";